import { toast, Slide } from "react-toastify";
// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;
// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num;
// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");
// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};
/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };
  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData");
export const getUserData = () => JSON.parse(localStorage.getItem("userData"));
/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return "/";
  if (userRole === "client") return "/access-control";
  return "/login";
};
// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});
export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export function showSuccessMessage(message) {
  toast.success(message ?? "Successful.", {
    icon: true,
    hideProgressBar: false,
    closeButton: true,
  });
}
export function showErrorMessage(message = "An error occurred.") {
  toast.error(message, {
    icon: true,
    hideProgressBar: false,
    closeButton: true,
    timeout: 8000,
    // transition: Slide,
  });
}
function checkTextIfNull(text) {
  return text != null ? text : "N/A";
}
export const editCSV = (json, tag) => {

  // remove brackets and split the string into an array of numbers
  const convertDays = (str) => {
    const nums = str.replace(/\[|\]/g, '').split(',').map(Number);

    const converted = nums.map(num => {
      switch (num) {
        case 1:
          return "Monday (1)";
        case 2:
          return "Tuesday (2)";
        case 3:
          return "Wednesday (3)";
        case 4:
          return "Thursday (4)";
        case 5:
          return "Friday (5)";
        case 6:
          return "Saturday (6)";
        case 7:
          return "Sunday (7)";
        default:
          return "N/A";
      }
    });

    return converted.join(' - ');
  };

  const payoutOptionFallback = (option) => {
    if (option === "bank_account") {
      return "Bank Account";
    }
    if (option === "meeza_card") {
      return "Meeza Card";
    }
    if (option === "meeza_wallet") {
      return "Meeza Wallet";
    }
    return "None";
  };

  switch (tag) {
    case "account":
      return json.map((item) => {
        // TODO: change this based on country
        let verificationFiles = null;
        if (item?.accountVerification) {
          verificationFiles = JSON.parse(item?.accountVerification?.data);
        }
        return {
          "Test Account": (item.reference?.referer === "XZC14824" || item.reference?.refererCode === "XZC14824") ? "True" : "False",
          "Merchant ID": item.merchantid,
          "Merchant Name": item.name,
          "Merchant Surname": item.surname,
          "Business Type": item.businessType,
          "Merchant Email": item.email,
          "Merchant GSM": item.gsm,
          "Registration Date": item.createdDate,
          "Merchant Country": item.countryCode.toUpperCase(),
          "Referer Code": item.reference?.refererCode ? item.reference?.refererCode : "N/A",
          "Reference Program": item.reference?.referer ? item.reference?.referer : "N/A",
          "Local Commission Rate": item.commission + " %",
          "Local Commission Amount": item.localCommissionAmount + " " + item.currencyCode.toUpperCase(),
          "Foreign Commission Rate": item.foreignCommission + " %",
          "Foreign Commission Amount": item.foreignCommissionAmount + " " + item.currencyCode.toUpperCase(),
          "Payout Days": convertDays(item.payoutDay),
          "Merchant Currency Code": item.merchantCurrencyCode,
          "Shop Name": item.marketname ? item.marketname : "N/A",
          "Adult Content": item.adult === 1 ? "YES" : "NO",
          "Risk Status": item.riskStatus == 0 ? `NO (merchant is marked as low-risk)` : `YES (merchant is marked as high-risk)`,
          "Trace Status": item.traceStatus == 0 ? `NO (actions of merchant are not traced)` : `YES (actions of merchant are traced)`,
          "Capture Status": item.isPayoutEnabled == 0 ? `NO (merchant will not get payout)` : `YES (merchant will get payout)`,
          "KYC Verification Status": item.verify == 0 ? `NO (merchant is not verified)` : `YES (merchant is verified)`,
          "KYC Verification Date": item.verifiedAt,
          "Preferred Payout Option": item.preferredPayoutOption ? payoutOptionFallback(item.preferredPayoutOption) : 'N/A',
          "Bank Name": (verificationFiles && verificationFiles.bank_name) ? verificationFiles.bank_name : 'N/A',
          "Account Name": (verificationFiles && verificationFiles.account_name) ? verificationFiles.account_name : 'N/A',
          "Bank Account Name": (verificationFiles && verificationFiles.bank_account_name) ? verificationFiles.bank_account_name : 'N/A',
          "Bank Account Number": (verificationFiles && verificationFiles.bank_account_number) ? verificationFiles.bank_account_number : 'N/A',
          "IBAN": (verificationFiles && verificationFiles.iban) ? verificationFiles.iban : 'N/A',
          "BIC / Swift": (verificationFiles && verificationFiles.bic_swift) ? verificationFiles.bic_swift : 'N/A',
          "Maroof ID": (verificationFiles && verificationFiles.maroof_id) ? verificationFiles.maroof_id : 'N/A',
          "Meeza Card": (verificationFiles && verificationFiles.meeza_card) ? verificationFiles.meeza_card : 'N/A',
          "Meeza Wallet": (verificationFiles && verificationFiles.meeza_wallet) ? verificationFiles.meeza_wallet : 'N/A',
          "Sales Representative": item.sales_representative,
        };
      });
    case "sale":
      return json.map((item) => {
        return {
          "Test Account": (item.seller?.reference?.referer === "XZC14824" || item.seller?.reference?.refererCode === "XZC14824") ? "True" : "False",
          "Transaction ID": checkTextIfNull(item?.trxId),
          "PF ID": checkTextIfNull(item?.pfRef),
          "Transaction Date": checkTextIfNull(item?.date),
          "Capture Date": checkTextIfNull(item?.captureDate),
          "Product Name": checkTextIfNull(item?.title),
          "Transaction Amount": checkTextIfNull(item?.originalPrice),
          "Transaction Type": `${checkTextIfNull(item?.credit_debit_type ? item.credit_debit_type.toUpperCase().replaceAll("_", " ") : "")} ${checkTextIfNull(item.credit_debit ? item.credit_debit.toUpperCase() : "SALE")}`,
          "Payment Method": checkTextIfNull(item?.paymentMethod),
          "Credit Card First 6 Digits": checkTextIfNull(item?.ccFirstSix),
          "Credit Card Last 4 Digits": checkTextIfNull(item?.ccLastFour),
          "Commission Rate": checkTextIfNull(item?.commission),
          "Commission Amount": checkTextIfNull(item?.commissionAmount),
          "Amount After Refund": checkTextIfNull(item?.totalprice),
          "Chargeback Status": checkTextIfNull(item?.chargeback),
          "Shipping Company": checkTextIfNull(item?.shippingCompany),
          "Shipment ID": checkTextIfNull(item?.shippingId),
          "Merchant ID": checkTextIfNull(item.seller?.merchantid),
          "Merchant Name": checkTextIfNull(item.seller?.name),
          "Merchant Surname": checkTextIfNull(item.seller?.surname),
          "Merchant Country": checkTextIfNull(item?.countryCode?.toUpperCase()),
          "Merchant Currency": checkTextIfNull(item?.currencyCode?.toUpperCase()),
          "Sales Representative": checkTextIfNull(item.seller?.sales_representative),
          "Customer Name": checkTextIfNull(item?.name),
          "Customer Surname": checkTextIfNull(item?.surname),
          "Customer Email": checkTextIfNull(item?.email),
          "Customer GSM": checkTextIfNull(item?.gsm),
          // "Customer Address": item.address, //TODO: clear csv breaking chars
        };
      });
    default:
      return json;
  }
};
